module.exports = __webpack_public_path__ + "img/full5-min.f5ca62d8.png";